"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryParseURL = void 0;
function tryParseURL(url, base) {
    // implement cross platform `URL.canParse` since this function
    // only exists in the DOM and not in Node
    try {
        return new URL(url, base);
    }
    catch { }
}
exports.tryParseURL = tryParseURL;
